import {View, Text, TouchableOpacity} from 'react-native';
import React, {useEffect, useState} from 'react';
import {styles} from './styles';
import OrdersModal from './components/OrdersModal/OrdersModal';
import NFModal from './components/NFModal/NFModal';
import moment from 'moment';
import TransitModal from './components/TransitModal/TransitModal';
import {Colors} from '../../../../constants/Colors';
import {useNavigation} from '@react-navigation/native';
import {NavigationProps} from '../../../../navigation/Routes';
import {AppRoutes} from '../../../../navigation/Routes.types';
import {
  getPaymentMethodLabel,
  formatDeliveryDate,
} from '../../../../utils/orderFormat';
interface IOrderCard {
  item: IStatusPedido;
  onPress: () => void;
  returnSort: (val: string) => void;
}

const OrderCard = ({
  name,
  date,
  onPress,
  status,
  item,
  returnSort,
}: IOrderCard) => {
  const [drop, setDrop] = useState<boolean>(false);
  const [showOrdersModal, setShowOrdersModal] = useState<boolean>(false);
  const [orderStatus, setOrderStatus] = useState<Object>({
    status: '',
    color: '',
    step: '',
  });
  const [showNfModal, setShowNfModal] = useState<boolean>(false);
  const [showTransitModal, setShowTransitModal] = useState<boolean>(false);

  const {navigate} = useNavigation<NavigationProps>();

  const handleCloseOrdersModal = () => {
    setShowOrdersModal(false);
  };

  const handleOpenOrdersModal = step => {
    if (item.Itens.length === 0) return;
    if (step?.name === 'cor_ped') {
      setShowOrdersModal(true);
    }
    if (step?.name === 'cor_faturado' && step?.status === 'success') {
      setShowNfModal(true);
    }
    if (step?.name === 'cor_encaminhado' && step?.status === 'success') {
      setShowTransitModal(true);
    }
  };

  function colors(status) {
    switch (status) {
      case 'CANCELADO':
      case 'PEDIDO CANCELADO':
      case 'PEDIDO NAO FATURADO': // Depois da terceira vermelha e anteriores verde
      case 'PEDIDO NOTA CANCELADA': // Depois da terceira vermelha e anteriores verde
      case 'PEDIDO RETORNADO': // Todas verdes e a ultima vermelha
      case 'RETORNADO/DEVOLVIDO': // Todas verdes e a ultima vermelha
        return {status, label: 'danger', step: 'cor_ped', color: Colors.RedPallete.red};

      case 'PARCIALMENTE ENTREGUE':
      case 'PEDIDO PARCIALMENTE RECUSADO':
      case 'PEDIDO PARCIALMENTE RETORNADO':
        return {
          status,
          label: 'warning',
          step: 'cor_entregue',
          color: Colors.OrangePallete.orange,
        };

      case 'PEDIDO ENTREGUE':
        return {
          status,
          label: 'success',
          step: 'cor_entregue',
          color: Colors.GreenPallete.greenOne,
        };

      case 'FINANCEIRO APROVADO':
      case 'PEDIDO CONFIRMADO':
      case 'PEDIDO FATURADO':
      case 'PEDIDO EM SEPARACAO':
        return {status, label: 'info', step: 'cor_separacao', color: Colors.BluePallete.blue};

      case 'PEDIDO EM TRANSITO':
        return {
          status,
          label: 'info',
          step: 'cor_encaminhado',
          color: Colors.BluePallete.blue,
        };

      case 'FATURAMENTO PENDENTE':
        return {status, label: 'info', step: 'cor_faturado', color: Colors.BluePallete.blue};

      case 'FINANCEIRO NAO APROVADO':
      case 'PEDIDO EM PROCESSAMENTO':
      case 'PEDIDO RECEBIDO':
        return {status, label: 'info', step: 'cor_analise', color: Colors.BluePallete.blue};

      default:
        return {status, label: '', step: '', color: ''};
    }
  }

  const returnFormattedStatus = {
    cor_ped: 'Pedido Confirmado',
    cor_analise: 'Análise de Crédito',
    cor_faturado: 'Pedido Faturado',
    cor_separacao: 'Separação Interna',
    cor_encaminhado: 'Pedido em Trânsito',
    cor_entregue: 'Pedido Entregue',
  };

  const verifyOrderType = {
    ZS03: 'Bonificação',
    ZS11: 'Troca',
    ZS43: 'Compra',
    ZS07: 'Devolução',
  };

  useEffect(() => {
    const result = colors(item?.Status?.STATUS);

    if (item?.Status?.STATUS == 'FINANCEIRO NAO APROVADO') {
      item.Status.STATUS = 'PEDIDO EM PROCESSAMENTO';
    } else if (item?.Status?.STATUS == 'PEDIDO PARCIALMENTE RECUSADO' || item?.Status?.STATUS == 'PEDIDO PARCIALMENTE RETORNADO') {
      item.Status.STATUS = 'PARCIALMENTE ENTREGUE';
    }

    setOrderStatus(result);
  }, [item?.Status?.STATUS]);

  const getFirstBEZEI = () => {
    let status = '';
    if (item?.Itens?.Item?.length) {
      status = item?.Itens?.Item?.find(current => !!current.BEZEI)?.BEZEI || '';
    } else if (item?.Itens?.Item?.BEZEI) {
      status = item?.Itens?.Item?.BEZEI || '';
    }
    if (Array.isArray(status)) {
      return '';
    }
    return status.endsWith('por')
      ? status.trim().slice(0, -3)
      : status.endsWith('solicitado p')
      ? status.trim().slice(0, -2)
      : status;
  };

  const calculateSubtotal = () => {
      if (item?.Itens?.Item) {
        if(Array.isArray(item?.Itens?.Item)) {
          let total = 0;
          for (let i = 0; i < item?.Itens?.Item?.length; i++) {
            const cmpre = item?.Itens?.Item[i]?.CMPRE;
            const kwmeng = parseInt(item?.Itens?.Item[i]?.KWMENG, 10) || 0;
            if (cmpre) {
              const valor = Number(cmpre.replace(/\./g, '').replace(',', '.'));
              const subtotal = valor * Number(kwmeng);
              total += subtotal;
            }
          }
          return total
        } else {
            const cmpre = item?.Itens?.Item?.CMPRE;
            const kwmeng = parseInt(item?.Itens?.Item?.KWMENG, 10) || 0;
            if (cmpre) {
              const valor = Number(cmpre.replace(/\./g, '').replace(',', '.'));
              return  valor * Number(kwmeng);
            }
        }
      }
      return 0;
    };



  return (
    <View style={styles.CardContainer}>
      <View style={styles.CardContent}>
          <Text style={styles.label}>
            Pedido: {item?.['@attributes']?.ORDEM}
          </Text>
          <View style={styles.ContainerDate}>
            <Text style={styles.preDate}>Data de criação: </Text>
            <Text style={styles.dateText}>
              {moment(item?.Status?.ERDAT, 'YYYY-MM-DD').format('DD/MM/YYYY')}
            </Text>
          </View>
          <View style={styles.ContainerDate}>
            <Text style={styles.preDate}>Tipo de pedido: </Text>
            <Text style={styles.dateText}>
              {verifyOrderType[item?.Status?.AUART]}
            </Text>
          </View>
          <View style={styles.ContainerDate}>
            <Text style={styles.preDate}>Status: </Text>
            <Text style={[styles.dateText, {color: orderStatus.color}]}>
              {!!orderStatus?.step && orderStatus?.label !== 'success'
                ? item?.Status?.STATUS?.toLowerCase().replace(/\b\w/g, char =>
                    char.toUpperCase(),
                  )
                : returnFormattedStatus[orderStatus?.step]}
            </Text>
          </View>
          {!!getPaymentMethodLabel(
            item?.Status?.FORM_PGT ?? item?.FORM_PGT,
          ) && (
            <View style={styles.ContainerDate}>
              <Text style={styles.preDate}>Forma de pagamento: </Text>
              <Text style={styles.dateText}>
                {getPaymentMethodLabel(item?.Status?.FORM_PGT ?? item?.FORM_PGT)}
              </Text>
            </View>
          )}
          {!!formatDeliveryDate(
            item?.Status?.DT_REMESSA ?? item?.DT_REMESSA,
          ) && (
            <View style={styles.ContainerDate}>
              <Text style={styles.preDate}>Data provável de entrega: </Text>
              <Text style={styles.dateText}>
                {formatDeliveryDate(item?.Status?.DT_REMESSA ?? item?.DT_REMESSA)}
              </Text>
            </View>
          )}
          {/* <View style={styles.ContainerDate}>
            <Text style={styles.preDate}>Subtotal: </Text>
            <Text style={styles.dateText}>
              {calculateSubtotal().toLocaleString('pt-BR', {
                style: 'currency',
                currency: 'BRL',
              })}
            </Text>
          </View> */}
          {orderStatus.step == 'cor_ped' && getFirstBEZEI() && (
            <View style={styles.ContainerDate}>
              <Text style={styles.preDate}>Motivo de Cancelamento: </Text>
              <Text style={[styles.dateText, {color: orderStatus.color}]}>
                {getFirstBEZEI()}
              </Text>
            </View>
          )}

          <TouchableOpacity
            disabled={!orderStatus?.step}
            onPress={() => navigate(AppRoutes.ORDER_DETAILS, {item: item})}
            style={[
              styles.smallButton,
              {
                backgroundColor: Colors.RedPallete.red,
              },
            ]}>
            <Text style={styles.buttonText}>Detalhes do pedido</Text>
          </TouchableOpacity>
          
      </View>

      <OrdersModal
        returnSort={(val: string) => returnSort(val)}
        item={item}
        visible={showOrdersModal}
        onRequestClose={handleCloseOrdersModal}
      />
      <NFModal
        item={item}
        visible={showNfModal}
        onRequestClose={() => setShowNfModal(false)}
      />
      <TransitModal
        item={item}
        visible={showTransitModal}
        onRequestClose={() => setShowTransitModal(false)}
      />
    </View>
  );
};

export default OrderCard;
